"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const r=require("./index62.js"),l=require("./index52.js");var t=r.fails,o=l.global,a=o.RegExp,s=t(function(){var e=a(".","s");return!(e.dotAll&&e.test(`
`)&&e.flags==="s")});exports.regexpUnsupportedDotAll=s;
